/**
 * LG — Selector visual de acabados (snippets/lg-variant-thumbs.liquid).
 *
 * Solo gestiona el botón «+N más / Ver menos». El cambio de variante lo sigue
 * haciendo Dawn (variant-selects → product-info.js) con los radios de siempre.
 *
 * Dawn sustituye <variant-selects> entero tras cada cambio de opción (lo
 * re-renderiza el servidor), así que el estado «desplegado» se recuerda por
 * producto+opción en memoria y se re-aplica cuando el nuevo elemento se conecta.
 */
(function () {
  if (customElements.get('lg-variant-thumbs')) return;
  const expanded = new Set();

  class LgVariantThumbs extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('.lg-vthumbs__more');
      if (!this.button) return;
      if (expanded.has(this.dataset.key)) this.setExpanded(true);
      this.onClick = () => this.setExpanded(this.hasAttribute('data-collapsed'));
      this.button.addEventListener('click', this.onClick);
    }

    disconnectedCallback() {
      if (this.button && this.onClick) this.button.removeEventListener('click', this.onClick);
    }

    setExpanded(open) {
      this.toggleAttribute('data-collapsed', !open);
      this.button.setAttribute('aria-expanded', String(open));
      this.button.textContent = open ? this.button.dataset.lessLabel : this.button.dataset.moreLabel;
      if (open) expanded.add(this.dataset.key);
      else expanded.delete(this.dataset.key);
    }
  }

  customElements.define('lg-variant-thumbs', LgVariantThumbs);
})();
